module.exports = __webpack_public_path__ + "static/img/3.b79de87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/3.jpg
// module id = GMa5
// module chunks = 1